import React, { useEffect, useState } from "react";
import { adminGetDailyStatistics } from "../../services/botService";
import ZAIIcon from "../../AI-COMPONENT/ZAIIcon";

const DailyStatistics = () => {
    const [userStats, setUserStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await adminGetDailyStatistics();
                if (response.success && response.data.length > 0) {
                    // normal user will only get their own object
                    setUserStats(response.data[0]);
                } else {
                    setError(response.message || "No statistics found");
                }
            } catch (err) {
                console.error(err);
                setError("Error fetching data");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) return <p className="text-center py-10"><ZAIIcon /></p>;
    if (error) return <p className="text-center py-10 text-red-500">{error}</p>;
    if (!userStats) return <p className="text-center py-10 text-gray-400">No data available</p>;

    return (
        <div className="p-4">
            <div className="mb-8 bg-gray-800 rounded-xl p-4 shadow-lg">
                <p
                    className={`text-lg font-semibold ${
                        userStats.total_profit < 0
                            ? "text-red-400"
                            : userStats.total_profit === 0
                                ? "text-blue-400"
                                : "text-green-400"
                    }`}
                >
                    Total Profit: ${userStats.total_profit.toFixed(2)}
                </p>

                {userStats.message && (
                    <p className="mt-2 text-yellow-300 italic">{userStats.message}</p>
                )}

                <div className="space-y-3 mt-4">
                    {userStats.days.map((dayData, index) => {
                        const rawProgress = (dayData.profit / dayData.target) * 100;
                        const progress = Math.min(Math.max(Math.abs(rawProgress), 0), 100);

                        let barColor = "bg-blue-500"; // zero
                        if (dayData.profit < 0) barColor = "bg-red-500";
                        else if (dayData.profit > 0) barColor = "bg-green-500";

                        return (
                            <div key={index} className="bg-gray-700 p-3 rounded-lg">
                                <div className="flex justify-between text-gray-200 text-sm mb-1">
                                    <span>{new Date(dayData.day).toLocaleDateString()}</span>
                                    <span>
                    Profit: ${dayData.profit.toFixed(2)} / Target: ${dayData.target} (
                                        {rawProgress.toFixed(1)}%)
                  </span>
                                </div>
                                <div className="w-full bg-gray-600 h-3 rounded-full">
                                    <div
                                        className={`h-3 rounded-full ${barColor}`}
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default DailyStatistics;
